import React from "react";
import styled from "@emotion/styled";
import { Form, Input, Button, Checkbox } from "antd";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";

const WelcomeQuiz = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Background>
        <GreenButton
          onClick={() => navigate("/login/quiz")}
          style={{
            background: "#16AF7B",
            color: "white",
          }}
        >
          เข้าสู่ระบบทำแบบทดสอบ
        </GreenButton>
        <GreenButton
          onClick={() => navigate("/register/quiz")}
          style={{ marginTop: "16px" }}
        >
          ลงทะเบียนทำแบบทดสอบ
        </GreenButton>
      </Background>
    </Container>
  );
};

const GreenButton = styled.button`
  width: 220px;
  height: 51px;
  left: 314px;
  top: 420px;

  /* Primary/Green 50 */

  background: #b5f6df;
  /* Primary/Green 400 */

  border: 1px solid #16af7b;
  border-radius: 100px;
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 23px;
  /* identical to box height, or 121% */

  letter-spacing: -0.02em;

  /* Primary/Green 400 */

  color: #16af7b;
`;

const Container = styled.div`
  width: 100%;
  background-color: #fffbeb;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Background = styled.div`
  width: 100%;
  height: calc(100vh - 154px - 60px - 40px);
  max-width: 1144px;

  background-color: white;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;

  padding-bottom: 80px;
  padding-top: 140px;

  span {
    font-family: "Noto Sans Thai";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    // margin-top: 8px;
    text-align: center;

    color: #4b5768;
  }

  ${responsive.tablet(css`
    max-width: 834px;
    padding-bottom: 50px;
    padding-top: 140px;
  `)}

  ${responsive.mobile(css`
    max-width: 375px;
    padding-bottom: 40px;
    padding-top: 40px;
  `)}
`;

export default WelcomeQuiz;
